import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInvalidateHomeState } from '../../home/hooks/use-home-state'
import { outreachApi, outreachStatusQueryKey } from '../api'

export function useEnableOutreachMutation(startupId: string) {
  const queryClient = useQueryClient()
  // Resuming here changes what Home says and what the sidebar CTA offers.
  // Without this the founder resumes on /outreach, walks to Home, and is told
  // their campaign is still paused until something else happens to refetch.
  const invalidateHome = useInvalidateHomeState(startupId)
  return useMutation({
    mutationFn: () => outreachApi.enable(startupId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachStatusQueryKey(startupId) })
      await invalidateHome()
    },
  })
}
